import { FormFieldGroup, FormLabel, FormSelect, FormRadioGroup, FormDatePicker } from '$components'
import { Input } from './index'
import { DogBreed, Gender } from '$api-client/types.gen'
import { useState } from 'react'
import { useInfiniteSizeCategoryOptions } from '$hooks/use-infinite-size-category-options'
import { useInfiniteCoatTypeOptions } from '$hooks/use-infinite-coat-type-options'
import { PetOptionSettingsLink } from '$components'

export function UpdatePetInformationContent() {
  const [breedSearch, setBreedSearch] = useState<string>('')
  const { options: sizeOptions, search: sizeSearch } = useInfiniteSizeCategoryOptions()
  const { options: coatOptions, search: coatSearch } = useInfiniteCoatTypeOptions()

  return (
    <div className="flex flex-col gap-6 flex-grow">
      <FormFieldGroup>
        <FormLabel htmlFor={Input.Breed}>
          Breed
        </FormLabel>
        <FormSelect
          name={Input.Breed}
          placeholder="Select breed..."
          clearable
          search={{
            search: breedSearch,
            onSearchChange: setBreedSearch,
          }}
          options={Object.entries(DogBreed).map(([_, value]) => ({ id: value, value }))}
        />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.SizeCategory}>
          Size Category
        </FormLabel>

        <FormSelect
          name={Input.SizeCategory}
          placeholder="Select size..."
          options={sizeOptions}
          search={sizeSearch}
        />

        <PetOptionSettingsLink type="size" />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.CoatType}>
          Coat Type
        </FormLabel>

        <FormSelect
          name={Input.CoatType}
          placeholder="Select coat type..."
          options={coatOptions}
          search={coatSearch}
        />

        <PetOptionSettingsLink type="coat" />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.BirthDate}>
          Date of Birth
        </FormLabel>
        <FormDatePicker name={Input.BirthDate} />
      </FormFieldGroup>

      <FormFieldGroup>
        <FormLabel htmlFor={Input.Gender}>
          Gender
        </FormLabel>
        <FormRadioGroup
          name={Input.Gender}
          options={Object.entries(Gender).map(([id, value]) => ({
            id,
            label: value,
            value,
          }))}
        />
      </FormFieldGroup>
    </div>
  )
}
